import getConfig from 'next/config'

import {
  UseUserAddressesProps,
  useGetUserAddresses as useGetUserAddressesLib,
} from '@nx/api'

const { publicRuntimeConfig } = getConfig()

export const useGetUserAddresses = ({
  clientNo,
}: {
  clientNo?: UseUserAddressesProps['clientNo']
}) =>
  useGetUserAddressesLib({ baseUrl: publicRuntimeConfig.WEB_API_URL, clientNo })
